"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreeModeStyle = void 0;
const typestyle_1 = require("typestyle");
exports.FreeModeStyle = (0, typestyle_1.stylesheet)({
    controls: {
        height: '44px'
    }
});
